module.exports = __webpack_public_path__ + "static/media/nightCity.7f8cb7f9.jpg";